import * as types from "./comprovanteSolicitacao.actionTypes";

export default {
  setComprovanteSolicitacao: data => ({
    type: types.SET_COMPROVANTE_SOLICITACAO,
    payload: data
  }),
  getComprovanteSolicitacao: id => ({
    type: types.GET_COMPROVANTE_SOLICITACAO,
    payload: id
  }),
  getImprimirComprovante: data => ({
    type: types.GET_IMPRIMIR_COMPROVANTE,
    payload: data
  })
}
